import { useEffect, useState } from "react";
import { api } from "../api";
import { ContactSummary } from "../types";
import { AdminShell } from "../components/admin/AdminShell";
import { formatPhone, initialsFor } from "../utils/contacts";
import { formatCreatedAt } from "../utils/date";
import { parseBookingNote } from "../utils/bookings";

export function AdminContactsPage() {
  const [contacts, setContacts] = useState<ContactSummary[]>([]);
  const [selectedContactId, setSelectedContactId] = useState("");
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.getContacts().then(setContacts);
  }, []);

  const filteredContacts = contacts.filter((contact) => {
    const value = `${contact.name} ${contact.email} ${contact.phone} ${contact.eventTitles.join(" ")}`.toLowerCase();
    return value.includes(query.toLowerCase().trim());
  });
  const selectedContact = contacts.find((contact) => contact.id === selectedContactId) || filteredContacts[0] || contacts[0];

  useEffect(() => {
    if (!selectedContactId && filteredContacts[0]) setSelectedContactId(filteredContacts[0].id);
  }, [filteredContacts, selectedContactId]);

  return (
    <AdminShell active="contacts" title="Contacts">
      <section className="contacts-page">
        <div className="contacts-toolbar">
          <input
            type="search"
            placeholder="Name, email, phone хайх"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
          <small>{filteredContacts.length} contact • {contacts.reduce((sum, contact) => sum + contact.totalBookings, 0)} booking</small>
        </div>

        <div className="contacts-layout">
          <section className="contacts-table-card">
            <div className="contacts-grid contacts-head">
              <span>Name</span>
              <span>Email</span>
              <span>Phone number</span>
              <span>Bookings</span>
              <span>Last meeting</span>
              <span>Next meeting</span>
            </div>
            {filteredContacts.map((contact) => (
              <button
                className={selectedContact?.id === contact.id ? "contacts-grid contact-row active" : "contacts-grid contact-row"}
                type="button"
                key={contact.id}
                onClick={() => setSelectedContactId(contact.id)}
              >
                <span className="contact-name-cell">
                  <b>{initialsFor(contact.name)}</b>
                  <strong>{contact.name}</strong>
                </span>
                <span>{contact.email || "-"}</span>
                <span>{formatPhone(contact.phone) || "-"}</span>
                <span>{contact.totalBookings} удаа</span>
                <span>{contact.lastMeetingDate || "-"}</span>
                <span>{contact.nextMeetingDate || "-"}</span>
              </button>
            ))}
            {!filteredContacts.length && <p className="empty-meetings">Contact олдсонгүй.</p>}
          </section>

          {selectedContact && (
            <aside className="contact-detail-card">
              <div className="contact-profile">
                <span>{initialsFor(selectedContact.name)}</span>
                <div>
                  <h2>{selectedContact.name}</h2>
                  <p>{selectedContact.totalBookings} booking • нийт {selectedContact.totalGuests || "-"} хүн</p>
                </div>
              </div>
              <div className="contact-stats">
                <div>
                  <small>Last meeting</small>
                  <strong>{selectedContact.lastMeetingDate || "-"}</strong>
                </div>
                <div>
                  <small>Next meeting</small>
                  <strong>{selectedContact.nextMeetingDate || "-"}</strong>
                </div>
                <div>
                  <small>First booked</small>
                  <strong>{formatCreatedAt(selectedContact.firstBookedAt)}</strong>
                </div>
              </div>
              <div className="contact-detail-list">
                <p><b>Email</b><span>{selectedContact.email || "-"}</span></p>
                <p><b>Phone</b><span>{formatPhone(selectedContact.phone) || "-"}</span></p>
                <p><b>Packages</b><span>{selectedContact.eventTitles.join(", ") || "-"}</span></p>
              </div>
              <h3>Meeting history</h3>
              <div className="contact-meetings">
                {selectedContact.bookings.map((booking) => {
                  const meta = parseBookingNote(booking.note);
                  return (
                    <article key={booking.id}>
                      <span>{booking.date} • {booking.time}</span>
                      <strong>{booking.eventTitle}</strong>
                      <small>Ирэх хүний тоо: {meta.quantity || "-"} • Бүртгэсэн: {formatCreatedAt(booking.createdAt)}</small>
                    </article>
                  );
                })}
              </div>
            </aside>
          )}
        </div>
      </section>
    </AdminShell>
  );
}
